import axios from 'axios';

const readCookie = ((name) => {
  // Using vue-cookies
  const cookieVal = this.$cookies.get('user')[name];
  return cookieVal;
});

const getToken = (() => {
  // NOTE: Mobile Safari will NOT save cookies. Use only for older browsers
  // which do not support the local storage API.
  let token = '';

  // --- Local Storage ---
  // Check browser support
  if (typeof (Storage) !== 'undefined') {
    // Retrieve
    token = localStorage.getItem('token');
  } else {
    // --- Cookie ---
    token = readCookie('user');
  }

  return token;
});

const token = getToken();

// const apiUrl = 'http://localhost:8080/';
const apiUrl = 'http://18.224.45.54:8080/';
const basicHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export default {
  getSummary() {
    return this.getOwners();
  },
  getEpics() {
    return axios({
      method: 'get',
      url: `${apiUrl}epics`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => response.data)
      .catch((err) => {
        console.log(`err: ${err}`);
        const apiError = {
          error: 'There was an error while attempting to retrieve data.',
        };

        return apiError;
      });
  },
  getMembers() {
    return axios({
      method: 'get',
      url: `${apiUrl}members`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => response.data)
      .catch((err) => {
        console.log(`err: ${err}`);
        const apiError = {
          error: 'There was an error while attempting to retrieve data.',
        };

        return apiError;
      });
  },
  getProjects() {
    return axios({
      method: 'get',
      url: `${apiUrl}projects`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => response.data)
      .catch((err) => {
        console.log(`err: ${err}`);
        const apiError = {
          error: 'There was an error while attempting to retrieve data.',
        };

        return apiError;
      });
  },
  postLogin(username, password) {
    return axios({
      method: 'post',
      url: `${apiUrl}users/login`,
      basicHeaders,
      auth: {
        username: `${username}`,
        password: `${password}`,
      },
    })
      .then(response => response.data)
      .catch((error) => {
        console.log(`error: ${JSON.stringify(error, null, '\t')}`);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(`error.response.data: ${error.response.data}`);
          console.log(`error.response.status: ${error.response.status}`);
          console.log(`error.response.headers: ${error.response.headers}`);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log('The request was made but no response was received.');
          console.log(`error.request: ${error.request}`);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(`error.message: ${error.message}`);
        }
        const apiError = {
          error: 'Login failed. Please try again.',
        };

        return apiError;
      });
  },
};
